import React from 'react';
import Button from "../UI/Button";
import {useRegistrationSteps} from "../../utilities/context/registration-steps/registration-steps-context";
import PlayStoreLink from "../PurchaseSteps/PlayStoreLink";
import {useNavigate} from "react-router-dom";

const ConfirmedEmailMessage = () => {

    const {setStep} = useRegistrationSteps();

    const navigate = useNavigate();

    const goToDashboard = () => {
        navigate('../login');
    }

    return (
        <div className="flex flex-col items-center">
            <div className="font-semibold text-2xl mb-4 text-ea_green_to">Account attivato</div>
            <div>Inizia subito ad utilizzare ediliziAPP e sfrutta la tua prova gratuita.</div>
            <div className="mb-4 mt-4">
                <div>Scarica l'APP</div>
                <PlayStoreLink/>
            </div>

            <div>
                <div onClick={goToDashboard} className="cursor-pointer hover:underline">Accedi alla tua area riservata</div>
            </div>

        </div>
    );
};

export default ConfirmedEmailMessage;